
import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useParty } from '../contexts/PartyContext';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import PartyDisplayPageRegular from './PartyDisplayPageRegular';

const PartyPageRouter: React.FC = () => {
  const { partyId } = useParams<{ partyId: string }>();
  const [searchParams] = useSearchParams();
  const { currentParty, setCurrentParty } = useParty();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!partyId) return;
    if (currentParty && currentParty.id === partyId) return;
    setLoading(true);
    setError(null);
    getDoc(doc(db, 'parties', partyId))
      .then((docSnap) => {
        if (docSnap.exists()) {
          const data = docSnap.data();
          setCurrentParty({
            id: docSnap.id,
            name: data.name || '',
            createdBy: data.createdBy || '',
            createdAt: data.createdAt?.toDate?.() || new Date(),
            expiresAt: data.expiresAt?.toDate?.(),
            tier: data.tier,
            settings: data.settings || {},
            currentSong: data.currentSong ? {
              ...data.currentSong,
              addedAt: data.currentSong.addedAt?.toDate?.()
            } : null,
            isActive: typeof data.isActive === 'boolean' ? data.isActive : true
          });
        } else {
          setError('Party not found');
        }
      })
      .catch((err) => {
        setError('Failed to load party');
      })
      .finally(() => setLoading(false));
  }, [partyId, currentParty, setCurrentParty]);

  if (loading) return <div>Loading party...</div>;
  if (error) return <div>{error}</div>;
  if (!currentParty || currentParty.id !== partyId) return <div>Loading party...</div>;

  // Query overrides for modes
  const mode = (searchParams.get('mode') || '').toLowerCase();
  // Default to main display page (phone mic page removed)
  return <PartyDisplayPageRegular />;
};

export default PartyPageRouter;
